import React, { useState } from "react";
import { AppBar, Toolbar, Typography, Box, IconButton, Menu, MenuItem } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import logo from "../assets/logo.jpg";

function Header() {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  return (
    <AppBar position="static" sx={{ backgroundColor: "#ffffff", color: "#000000", boxShadow: "none", borderBottom: "1px solid #ddd" }}>
      <Toolbar sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%" }}>
        {/* Mobile Menu Icon */}
        <Box sx={{ display: { xs: "flex", md: "none" }, alignItems: "center" }}>
          <IconButton edge="start" color="inherit" aria-label="menu" onClick={handleMenuOpen}>
            <MenuIcon />
          </IconButton>
        </Box>

        {/* Logo and Title */}
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", flexGrow: 1 }}>
          <img src={logo} alt="U&B Advocates Logo" style={{ height: "50px", marginRight: "10px" }} />
          <Typography variant="h6" component="div" sx={{ fontWeight: "bold", display: { xs: "block", sm: "block" } }}>
            U&B Advocates
          </Typography>
        </Box>

        {/* Desktop Navigation */}
        <Box sx={{ display: { xs: "none", md: "flex" }, gap: "20px" }}>
          <a href="#about" style={{ textDecoration: "none", color: "#000000" }}>Бидний тухай</a>
          <a href="#team" style={{ textDecoration: "none", color: "#000000" }}>Манай баг</a>
          <a href="#services" style={{ textDecoration: "none", color: "#000000" }}>Үйлчилгээ</a>
          <a href="#contact" style={{ textDecoration: "none", color: "#000000" }}>Холбоо барих</a>
        </Box>
      </Toolbar>

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
        sx={{ display: { xs: "block", md: "none" } }}
      >
        <MenuItem onClick={handleMenuClose} sx={{ width: "100vw" }}>
          <a href="#about" style={{ textDecoration: "none", color: "#000000", width: "100%" }}>Бидний тухай</a>
        </MenuItem>
        <MenuItem onClick={handleMenuClose} sx={{ width: "100vw" }}>
          <a href="#team" style={{ textDecoration: "none", color: "#000000", width: "100%" }}>Манай баг</a>
        </MenuItem>
        <MenuItem onClick={handleMenuClose} sx={{ width: "100vw" }}>
          <a href="#services" style={{ textDecoration: "none", color: "#000000", width: "100%" }}>Үйлчилгээ</a>
        </MenuItem>
        <MenuItem onClick={handleMenuClose} sx={{ width: "100vw" }}>
          <a href="#contact" style={{ textDecoration: "none", color: "#000000", width: "100%" }}>Холбоо барих</a>
        </MenuItem>
      </Menu>
    </AppBar>
  );
}

export default Header;